import { render } from "./PokemonDetail.vue?vue&type=template&id=67ff1d71"
import script from "./PokemonDetail.vue?vue&type=script&lang=ts"
export * from "./PokemonDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script